









































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Snackbar from '@/components/shared/Snackbar.vue';
import IRolePermission from '@/store/models/IRolePermission';
import moment from 'moment';
import IOutbound from '@/store/models/IOutbound';
import IOutboundDeliveryNotes from '@/store/models/IOutboundDeliveryNotes';

@Component({
    components: {
        Snackbar
    }
})
export default class OutboundsNoticeOfLossSelector extends Vue {
    @Prop({ type: Array, required: true })
    OutboundList !: IOutbound[];
    @Prop({ type: Array, required: true })
    OutboundDeliveryNotesList !: IOutboundDeliveryNotes[];
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];
    sortBy: string = 'code';
    sortDesc: boolean = false;
    outboundDeliveryNotesSelected : IOutboundDeliveryNotes[] = [];
    searchOutboundDeliveryNotes: string = "";
    outboundSelected: string = "";

    headersOutboundsDeliveryNotes: any = [
        { text: 'Company destination',
            align: 'start',
            value: 'companyDestinationName'
        },
        { text: 'Warehouse', value: 'warehouseName' },
        { text: 'Customer', value: 'customerName' },
        { text: 'Code', value: 'code' },
        { text: 'Delivery Note Code', value: 'code' },
        { text: 'Out. Dossier Number Source', value: 'codeSource' },
        { text: 'Out. Dossier Number Destination', value: 'codeDestination' },
        { text: 'Date Out', value: 'dateOut' }
    ];

    get outboundItems() : string[] {
        let inboundsCode: string[] = this.OutboundList.map(t => t.code);
        let inboundsCodeDestination: string[] = this.OutboundList.map(t => t.codeDestination);
        return inboundsCode.concat(inboundsCodeDestination);
    }

    get WarehouseName() {
        if (this.outboundDeliveryNotesSelected.length > 0) {
            return this.outboundDeliveryNotesSelected[0].warehouseName;
        }
        return "";
    }

    ToDateFormat(date: string) : string {
        if (date === "" || date === null) {
            return "";
        }
        return moment(new Date(date)).format('DD-MM-YYYY');
    }

    @Watch('outboundSelected')
    onChangeOutbound() {
        let outboundIndex: number = this.OutboundList.findIndex(i => i.code === this.outboundSelected || i.codeDestination === this.outboundSelected);
        let selectedOutbound = {} as IOutbound;
        if (outboundIndex !== -1) {
            selectedOutbound = this.OutboundList[outboundIndex];
        }
        this.$emit('onChangeOutbound', selectedOutbound);
    }

    @Watch('outboundDeliveryNotesSelected')
    onChangeSelectedOutboundDeliveryNotes() {
        this.$emit('onChangeSelectedOutboundDeliveryNotes', this.outboundDeliveryNotesSelected);
    }

    select(item : IOutboundDeliveryNotes) : void {
        let index : number = this.outboundDeliveryNotesSelected.findIndex(w => w.id === item.id);
        if (index === -1) {
            this.outboundDeliveryNotesSelected = [item];
        } else {
            let outboundDeliveryNotes = this.outboundDeliveryNotesSelected.find(w => w.id === item.id);
            if (!outboundDeliveryNotes) {
                this.outboundDeliveryNotesSelected = [];
            }
        }
    }

    showMessageInfo(message: string) {
        (this.$refs.snackbar as Snackbar).showInfo(message);
    }

    showMessageError(message: string) {
        (this.$refs.snackbar as Snackbar).showError(message);
    }
    
    showMessageWarning(message: string) {
        (this.$refs.snackbar as Snackbar).showWarning(message);
    }
}
